'use client';
import { Button } from '@curology/ui-components-web/react/Button';
import { EditIcon } from '@curology/ui-components-web/react/Icon/icons/EditIcon';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Patient } from '@/types/productSelectionAndCheckout/types';
import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

import { CHECKOUT_STATES } from '../consts/checkoutStates';

const ShippingAddressPlaceholder: React.FC<{
  patient: Patient;
  checkoutState: string;
  setCheckoutState: React.Dispatch<React.SetStateAction<string>>;
}> = ({ patient, checkoutState, setCheckoutState }) => {
  if (
    checkoutState !== CHECKOUT_STATES.ccEntry &&
    checkoutState !== CHECKOUT_STATES.ccAndShippingAddressCompleted
  ) {
    return null;
  }

  return patient.hasCompletedShippingAddressEntry ? (
    <div className="cur-bg-surface-neutral cur-mt-4 cur-p-4">
      <Button
        buttonType="text"
        className="cur-float-right"
        data-sentry-id="Edit address info"
        iconStart={<EditIcon />}
        onClick={() => {
          setCheckoutState(CHECKOUT_STATES.shippingAddressEntry);

          trackEvent(AnalyticsEvent.CHECKOUT_ADDRESS_EDIT_BUTTON_CLICKED, {
            card: 'address',
          });
        }}
        size="sm"
        state="dark"
      />
      <Typography size="subhead">Confirm shipping address</Typography>
      <Typography className="cur-mt-4" size="meta">
        {patient.address1 +
          (patient.address2 ? ' ' + patient.address2 : '') +
          ` ${patient.city}, ${patient.state}, ${patient.zipcode}`}
      </Typography>
    </div>
  ) : (
    <div className="cur-bg-surface-neutral cur-mt-4 cur-p-4">
      <Typography size="subhead">Shipping address</Typography>
    </div>
  );
};

export default ShippingAddressPlaceholder;
